"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseAllSettledWithAbort = promiseAllSettledWithAbort;
const summarized_aggregate_error_1 = require("./summarized-aggregate-error");
async function promiseAllSettledWithAbort(promises, abortController) {
    const errors = [];
    const results = await Promise.allSettled(promises.map(async (p) => {
        try {
            return await p;
        }
        catch (e) {
            abortController.abort();
            throw e;
        }
    }));
    const resultValues = [];
    for (const result of results) {
        if (result.status === 'rejected') {
            errors.push(result.reason);
            resultValues.push(undefined);
        }
        else if (result.status === 'fulfilled') {
            resultValues.push(result.value);
        }
    }
    if (errors.length > 0) {
        if (errors.length === 1) {
            throw errors[0];
        }
        throw new summarized_aggregate_error_1.SummarizedAggregateError(errors);
    }
    return resultValues;
}
//# sourceMappingURL=promise-all-settled-with-abort.js.map